unit uDocEntrena;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, System.DateUtils;

type
  TFDocEntrena = class(TForm)
    WebPanel1: TPanel;
    WebEdit1: TEdit;
    WebDBNavigator1: TDBNavigator;
    WebToggleButton1: TToggleButton;
    WebToggleButton2: TToggleButton;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebPanel2: TPanel;
    WebLabel3: TLabel;
    WebDBEdit1: TDBEdit;
    WebLabel4: TLabel;
    WebDBEdit2: TDBEdit;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebDBEdit5: TDBEdit;
    WebButton1: TButton;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebLabel10: TLabel;
    WebDBMemo1: TDBMemo;
    WebLabel11: TLabel;
    WebDBGrid1: TDBGrid;
    WebDBGrid2: TDBGrid;
    TEntrenaDoc: TClientDataSet;
    CEntrenaDoc: TClientConnection;
    DsEntrenaDoc: TDataSource;
    TEntrenaDocRev: TClientDataSet;
    CEntrenaDocRev: TClientConnection;
    DsEntrenaDocRev: TDataSource;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebHttpRequest1: THttpRequest;
    WebDBCheckBox1: TDBCheckBox;
    WebDBCheckBox2: TDBCheckBox;
    WebDateTimePicker2: TDateTimePicker;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDateTimePicker1: TDateTimePicker;
    WebSpeedButton6: TSpeedButton;
    WebPanel3: TPanel;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    WebLabel12: TLabel;
    WebDBEdit8: TDBEdit;
    WebLabel13: TLabel;
    WebDBEdit9: TDBEdit;
    WebDateTimePicker3: TDateTimePicker;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebDateTimePicker4: TDateTimePicker;
    WebLabel17: TLabel;
    WebDBEdit11: TDBEdit;
    WebLabel18: TLabel;
    WebDBEdit12: TDBEdit;
    WebDBCheckBox3: TDBCheckBox;
    WebLabel14: TLabel;
    WebDBEdit10: TDBEdit;
    WebPanel4: TPanel;
    WebButton2: TButton;
    WebButton3: TButton;
    WebPanel5: TPanel;
    WebLabel25: TLabel;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebDBEdit17: TDBEdit;
    WebLabel20: TLabel;
    WebDBEdit14: TDBEdit;
    WebLabel19: TLabel;
    WebEdit2: TEdit;
    WebEdit3: TEdit;
    WebPanel6: TPanel;
    WebLabel21: TLabel;
    WebDBGrid3: TDBGrid;
    WebEdit4: TEdit;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    CPuestos: TClientConnection;
    TPuestos: TClientDataSet;
    DsPuestos: TDataSource;
    CEntrenaPuestos: TClientConnection;
    TEntrenaPuestos: TClientDataSet;
    DsEntrenaPuestos: TDataSource;
    WebLabel22: TLabel;
    WebEdit5: TEdit;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebLabel23: TLabel;
    WebDBEdit13: TDBEdit;
    WebDBGrid4: TDBGrid;
    WebButton4: TButton;
    WebButton5: TButton;
    procedure FormCreate(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure DsEntrenaDocDataChange(Sender: TObject; Field: TField);
    procedure CEntrenaDocRevDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure CEntrenaDocDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebToggleButton1Click(Sender: TObject);
    procedure WebToggleButton2Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure CEntrenaDocRevBeforeConnect(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebDBGrid3DblClick(Sender: TObject);
    procedure WebEdit2Enter(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure WebSpeedButton13Click(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebButton5Click(Sender: TObject);
  private
    { Private declarations }
    procedure ActivaCaptura;
    procedure DesactivaCaptura;
    procedure DesactivaTODO;
    procedure ImprimeFaltantes;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

type
  TProcedureRef = reference to procedure;

var
  FDocEntrena: TFDocEntrena;
  B1, B2: Integer;
  Memoria:String;


implementation

{$R *.dfm}

uses uRegEntEmp, uMenu, uSolicitudDwk;

function MMDDYYYY_To_YYYYMMDD_Dash_Manual(const S: string): string;
var
  M, D, Y: Word;
begin
//cambia fecha de 01/31/2025 a 2025-01-31
  M := StrToInt(Copy(S, 1, 2));
  D := StrToInt(Copy(S, 4, 2));
  Y := StrToInt(Copy(S, 7, 4));
  Result := Format('%.*d-%.*d-%.*d', [4, Y, 2, M, 2, D]);
end;

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFDocEntrena.CEntrenaDocDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
  B1 := 0;
  DesactivaCaptura;
end;

procedure TFDocEntrena.CEntrenaDocRevBeforeConnect(Sender: TObject);
begin
WebButton1.Visible := False;
WebSpeedButton6.Enabled:=False;
end;

procedure TFDocEntrena.CEntrenaDocRevDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
  TEntrenaDocRev.Active := True;
  WebDBGrid2.Enabled := True;
  WebDBGrid1.Enabled := True;
  WebButton1.Visible := True;
  WebButton2.Enabled := True;
  WebButton3.Enabled := True;
  WebSpeedButton6.Enabled:=True;
end;

procedure TFDocEntrena.DsEntrenaDocDataChange(Sender: TObject; Field: TField);
begin
  WebDBGrid1.Enabled := False;
  if B1 = 1 then
  begin
    B1 := 0;
    WebDBGrid1.Enabled := True;
    TEntrenaDoc.Locate('Codigo', Memoria, []);
    exit;
  end;
  WebDBGrid2.Enabled := False;
  WebButton2.Enabled := False;
  WebButton3.Enabled := True;
  CEntrenaDocRev.Command := httpGET;
  CEntrenaDocRev.URI :=
    'http://207.244.241.82:9000/entrenadocrevision1?Documento=' +
    TEntrenaDoc.FieldByName('Codigo').AsString;
  CEntrenaDocRev.Active := True;
end;

procedure TFDocEntrena.FormCreate(Sender: TObject);
begin
  // ESTO ES PARA USAR LA NAVEGACION DE LAS FLECHAS se regresa al Form1 o el principal
  asm
    window.onpopstate = function(event) {
    pas.uDocEntrena.FDocEntrena.Hide();
     };
  end;
  CEntrenaDoc.Command := httpGET;
  CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
  CEntrenaDoc.Active := True;
  CPuestos.Command := httpGET;
  CPuestos.URI := 'http://207.244.241.82:9000/Puestos';
  CPuestos.Active := True;
  CEntrenaPuestos.Command := httpGET;
  CEntrenaPuestos.URI := 'http://207.244.241.82:9000/EntrenaPuestos';
  CEntrenaPuestos.Active := True;
  DesactivaTODO;

  WebDateTimePicker1.Top:=WebDBEdit3.Top;
  WebDateTimePicker1.Left:=WebDBEdit3.Left;
  WebDateTimePicker1.Width:=WebDBEdit3.Width;
  WebDateTimePicker1.Height:=WebDBEdit3.Height;

  WebDateTimePicker2.Top:=WebDBEdit4.Top;
  WebDateTimePicker2.Left:=WebDBEdit4.Left;
  WebDateTimePicker2.Width:=WebDBEdit4.Width;
  WebDateTimePicker2.Height:=WebDBEdit4.Height;

  WebPanel3.Top:= 245;
  WebPanel3.Left:= 22;

  WebPanel5.Top:= 227;
  WebPanel5.Left:= 194;

  WebPanel6.Left:= 125;
  WebPanel6.Top:= 179;

  WebDBGrid4.Enabled:=False;
end;

procedure TFDocEntrena.WebButton1Click(Sender: TObject);
begin
WebPanel3.Visible:=True;
WebDateTimePicker3.Date := Now;
WebDateTimePicker4.Date := IncYear(Now, 1);
TEntrenaDocRev.Insert;
TEntrenaDocRev.FieldByName('RevisionAnt').AsString:=TEntrenaDoc.FieldByName('Revision').AsString;
TEntrenaDocRev.FieldByName('Documento').AsString:=TEntrenaDoc.FieldByName('Codigo').AsString;

end;

procedure TFDocEntrena.WebButton2Click(Sender: TObject);
begin
{  TFRegEntEmp.CreateNew(
    procedure(AForm: TObject)
    begin
      FRegEntEmp := TFRegEntEmp(AForm);
      FRegEntEmp.Show;
    end);}
WebPanel5.Visible:=True;
WebEdit2.Text:='';
WebEdit3.Text:='';
WebEdit5.Text:='';
WebEdit6.Text:='';
WebEdit7.Text:='';
WebEdit8.Text:='';
WebEdit9.Text:='';
WebEdit10.Text:='';
WebEdit11.Text:='';
WebEdit12.Text:='';
WebEdit13.Text:='';
WebEdit14.Text:='';
end;

procedure TFDocEntrena.WebButton3Click(Sender: TObject);
begin
  // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
  asm
    history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
  end;

  TFSolicitudDwk.CreateNew(
    procedure(AForm: TObject)
    begin
      FSolicitudDwk := TFSolicitudDwk(AForm);
      // Asignas valores a las variables globales del unit uSolicitudDwk
      uSolicitudDwk.MDocumento := TEntrenaDoc.FieldByName('Codigo').AsString;
      uSolicitudDwk.MAgrega := 'SI';

      FSolicitudDwk.Show;
    end);
end;

procedure TFDocEntrena.WebButton4Click(Sender: TObject);
begin
CEntrenaDoc.Active := False;
CEntrenaDoc.Active := True;
end;

procedure TFDocEntrena.WebButton5Click(Sender: TObject);
var
MCodigo, MRevision, MOpcion, URL : String;
begin
MCodigo:=    WebDBEdit10.Text;
MOpcion:=    'pEntrenaFaltantesRev';
MRevision:=  WebDBEdit8.Text;
 URL := 'http://207.244.241.82:9000/PDFReporteQR?Opcion='+MOpcion+'&Codigo='+MCodigo+
'&Revision='+MRevision;
  asm
  window.open(URL, '_blank');
  end;
end;

procedure TFDocEntrena.WebDBGrid3DblClick(Sender: TObject);
begin
WebEdit2.Text:=TPuestos.FieldByName('Clave').AsString;
WebEdit3.Text:=TPuestos.FieldByName('Puesto').AsString;
WebPanel6.Visible:=False;
end;

procedure TFDocEntrena.WebEdit2Enter(Sender: TObject);
begin
WebPanel6.Visible:=True;
end;

procedure TFDocEntrena.WebSpeedButton10Click(Sender: TObject);
var
  Data: TJSONObject;
begin
// Insertar post
    Data := TJSONObject.Create;
    try
      //Data.AddPair('Registro', TEntrenaPuestos.FieldByName('Registro').AsString);
      Data.AddPair('Puesto', TEntrenaPuestos.FieldByName('Puesto').AsString);
      Data.AddPair('PuestoDes', TEntrenaPuestos.FieldByName('PuestoDes').AsString);
      Data.AddPair('Documento', WebDBEdit17.Text);
      Data.AddPair('DocumentoDes', WebDBEdit14.Text);
      Data.AddPair('Revision', WebDBEdit5.Text);
      Data.AddPair('Depto1', WebEdit5.Text);
      Data.AddPair('Depto2', WebEdit6.Text);
      Data.AddPair('Depto3', WebEdit7.Text);
      Data.AddPair('Depto4', WebEdit8.Text);
      Data.AddPair('Depto5', WebEdit9.Text);
      Data.AddPair('Depto6', WebEdit10.Text);
      Data.AddPair('Depto7', WebEdit11.Text);
      Data.AddPair('Depto8', WebEdit12.Text);
      Data.AddPair('Depto9', WebEdit13.Text);
      Data.AddPair('Depto10', WebEdit14.Text);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaPuestos';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
ShowMessage('Entrenamiento agregado con exito!!');
WebPanel5.Visible:=False;
end;

procedure TFDocEntrena.WebSpeedButton11Click(Sender: TObject);
begin
if not TPuestos.Locate('Clave', WebEdit2.Text, []) Then
  begin
  ShowMessage('ERROR, NO EXISTE EL PUESTO: '+WebEdit2.Text);
  end;
end;

procedure TFDocEntrena.WebSpeedButton12Click(Sender: TObject);
begin
WebPanel6.Visible:=False;
end;

procedure TFDocEntrena.WebSpeedButton13Click(Sender: TObject);
begin
TEntrenaDoc.Locate('Descripcion', WebEdit1.Text, []);
end;

procedure TFDocEntrena.WebSpeedButton1Click(Sender: TObject);
begin
  B1 := 1;
  ActivaCaptura;
  TEntrenaDoc.Insert;
  WebDateTimePicker1.Date := Now;
  WebDateTimePicker2.Date := IncYear(Now, 1);
end;

procedure TFDocEntrena.WebSpeedButton2Click(Sender: TObject);
begin
  B1 := 1;
  B2 := 1;
  Memoria:=TEntrenaDoc.FieldByName('Codigo').AsString;
  TEntrenaDoc.Filtered:=False;
  TEntrenaDoc.Locate('Codigo', Memoria, []);
  ActivaCaptura;
  WebDateTimePicker1.Date :=
    StrToDate(MMDDYYYY_To_YYYYMMDD_Dash_Manual(TEntrenaDoc.FieldByName
    ('FechaAlta').AsString));
  WebDateTimePicker2.Date :=
    StrToDate(MMDDYYYY_To_YYYYMMDD_Dash_Manual(TEntrenaDoc.FieldByName
    ('FechaFin').AsString));
WebDBEdit5.Enabled:=False;
end;

procedure TFDocEntrena.WebSpeedButton3Click(Sender: TObject);
begin
  FDocEntrena.Hide;
end;

procedure TFDocEntrena.WebSpeedButton4Click(Sender: TObject);
begin
  B1 := 1;
  TEntrenaDoc.Cancel;
  DesactivaCaptura;
end;

procedure TFDocEntrena.WebSpeedButton5Click(Sender: TObject);
var
  Data: TJSONObject;
  Memoria:String;
begin
  Memoria:=WebDBEdit1.Text;
  B1 := 1;

  if B2 = 1 then
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Codigo', WebDBEdit1.Text);
      Data.AddPair('Descripcion', WebDBEdit2.Text);
      Data.AddPair('Revision', WebDBEdit5.Text);
      Data.AddPair('DuracionH', WebDBEdit6.Text);
      Data.AddPair('DuracionM', WebDBEdit7.Text);
      if WebDBCheckBox2.Checked = True then
        begin
        Data.AddPair('Vigente', 'True');
        end;
      if WebDBCheckBox1.Checked = True then
        begin
        Data.AddPair('Generico', 'True');
        end;
      Data.AddPair('Notas', WebDBMemo1.Text);

      Data.AddPair('FechaFin',DateToStr(WebDateTimePicker2.Date));
      Data.AddPair('FechaAlta',DateToStr(WebDateTimePicker1.Date));
      Data.AddPair('PorInstruccionDe', WebDBEdit13.Text);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaDoc';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPUT;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    DesactivaCaptura;
    SleepAsync(300,
      procedure
      begin
        TEntrenaDoc.Refresh;
        B1 := 1;
      end);
    exit;
    B2 := 0;
  end;

  Data := TJSONObject.Create;
  try
    Data.AddPair('Codigo', WebDBEdit1.Text);
    Data.AddPair('Descripcion', WebDBEdit2.Text);
    Data.AddPair('Revision', WebDBEdit5.Text);
    Data.AddPair('DuracionH', WebDBEdit6.Text);
    Data.AddPair('DuracionM', WebDBEdit7.Text);
      if WebDBCheckBox2.Checked = True then
        begin
        Data.AddPair('Vigente', 'True');
        end;
      if WebDBCheckBox1.Checked = True then
        begin
        Data.AddPair('Generico', 'True');
        end;
    Data.AddPair('Notas', WebDBMemo1.Text);
    Data.AddPair('FechaFin',DateToStr(WebDateTimePicker2.Date));
      Data.AddPair('FechaAlta',DateToStr(WebDateTimePicker1.Date));
      Data.AddPair('PorInstruccionDe',WebDBEdit13.Text);

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaDoc';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
  DesactivaCaptura;
  SleepAsync(300,
    procedure
    begin
      TEntrenaDoc.Refresh;
      B1 := 1;
    end);


end;

procedure TFDocEntrena.WebSpeedButton6Click(Sender: TObject);
begin
//TEntrenaDoc.Locate('Codigo', WebEdit1.Text, []);
if WebEdit1.Text > '' then
  begin
  CEntrenaDoc.Active := False;
  CEntrenaDoc.Command := httpGET;
  CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc?Documento='+WebEdit1.Text;
  CEntrenaDoc.Active := True;
  DesactivaTODO;
  end
else
  begin
  CEntrenaDoc.Active := False;
  CEntrenaDoc.Command := httpGET;
  CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
  CEntrenaDoc.Active := True;
  end;

end;

procedure TFDocEntrena.WebSpeedButton7Click(Sender: TObject);
begin
WebPanel3.Visible:=False;
TEntrenaDocRev.Cancel;
end;

procedure TFDocEntrena.WebSpeedButton8Click(Sender: TObject);
var
  Data: TJSONObject;
  MCodigo, MRevision, MOpcion, URL : String;
begin
//POSTEAR EN REVISIONES
Data := TJSONObject.Create;
  try
    MCodigo:=    WebDBEdit10.Text;
    MOpcion:=    'pEntrenaFaltantesRev';
    MRevision:=  WebDBEdit8.Text;

    Data.AddPair('Revision', WebDBEdit8.Text);
    Data.AddPair('Documento', WebDBEdit10.Text);
    Data.AddPair('Fecha', FormatDateTime('MM/DD/YYYY',WebDateTimePicker3.Date));
    Data.AddPair('Descripcion', WebDBEdit6.Text); // EL USUARIO
    Data.AddPair('RevisionAnt', WebDBEdit9.Text);
    Data.AddPair('Notas', WebDBEdit12.Text);
    Data.AddPair('FechaFin', FormatDateTime('MM/DD/YYYY',WebDateTimePicker4.Date));
    if TEntrenaDocRev.FieldByName('Entrena').AsBoolean = True then
    begin
      Data.AddPair('Entrena', 'True');
    end;

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/entrenadocrevision1';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
  WebDBGrid2.Enabled := False;
  CEntrenaDocRev.Command := httpGET;
  CEntrenaDocRev.URI :=
    'http://207.244.241.82:9000/entrenadocrevision1?Documento=' +
    TEntrenaDoc.FieldByName('Codigo').AsString;
  CEntrenaDocRev.Active := True;

  SleepAsync(300,
    procedure
    begin
      TEntrenaDocRev.Refresh;
    end);

Data := TJSONObject.Create;
    try
      Data.AddPair('Codigo', WebDBEdit1.Text);     //AQUI CAMBIA PARA PONER REVISION NUEVA
      Data.AddPair('Descripcion', WebDBEdit2.Text);
      Data.AddPair('Revision', WebDBEdit8.Text);
      Data.AddPair('DuracionH', WebDBEdit6.Text);
      Data.AddPair('DuracionM', WebDBEdit7.Text);
      Data.AddPair('Vigente', 'False');
      Data.AddPair('Generico', 'False');
      if TEntrenaDoc.FieldByName('Vigente').AsBoolean = True then
        begin
        Data.AddPair('Vigente', 'True');
        end;
      if TEntrenaDoc.FieldByName('Generico').AsBoolean = True then
        begin
        Data.AddPair('Generico', 'True');
        end;
      Data.AddPair('Notas', WebDBMemo1.Text);

      Data.AddPair('FechaFin',DateToStr(WebDateTimePicker2.Date));
      Data.AddPair('FechaAlta',DateToStr(WebDateTimePicker1.Date));
      Data.AddPair('PorInstruccionDe',WebDBEdit13.Text);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaDoc';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPUT;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    DesactivaCaptura;
    SleepAsync(300,
      procedure
      begin
        TEntrenaDoc.Refresh;
        B1 := 1;
      end);
WebPanel3.Visible:=False;
//ImprimeFaltantes;


  URL := 'http://207.244.241.82:9000/PDFReporteQR?Opcion='+MOpcion+'&Codigo='+MCodigo+
'&Revision='+MRevision;
  asm
  window.open(URL, '_blank');
  end;
end;

procedure TFDocEntrena.ImprimeFaltantes;
begin
//http://207.244.241.82:9000/PDFReporteQR?Opcion=pEntrenaFaltantesRev&Codigo=D1&Revision=op

end;

procedure TFDocEntrena.WebSpeedButton9Click(Sender: TObject);
begin
WebPanel5.Visible:=False;
end;

procedure TFDocEntrena.WebToggleButton1Click(Sender: TObject);
begin
  WebToggleButton2.Checked := False;
  if WebToggleButton1.Checked = True then
  begin
    TEntrenaDoc.Filtered := False;
    TEntrenaDoc.Filter := 'Vigente = ' + chr(39) + 'True' + chr(39);
    TEntrenaDoc.Filtered := True;
  end;
  if WebToggleButton1.Checked = False then
  begin
    TEntrenaDoc.Filtered := False;
  end;
end;

procedure TFDocEntrena.WebToggleButton2Click(Sender: TObject);
begin
  WebToggleButton1.Checked := False;
  if WebToggleButton2.Checked = True then
  begin
    TEntrenaDoc.Filtered := False;
    TEntrenaDoc.Filter := 'Generico = ' + chr(39) + 'True' + chr(39);
    TEntrenaDoc.Filtered := True;
  end;
  if WebToggleButton2.Checked = False then
  begin
    TEntrenaDoc.Filtered := False;
  end;
end;

procedure TFDocEntrena.ActivaCaptura;
begin
  WebDBEdit1.Enabled := True;
  WebDBEdit2.Enabled := True;
  WebDBEdit3.Enabled := True;
  WebDBEdit4.Enabled := True;
  WebDBEdit5.Enabled := True;
  WebDBEdit6.Enabled := True;
  WebDBEdit13.Enabled:= True;
  WebDBEdit7.Enabled := True;
  WebButton1.Enabled := True;
  WebButton5.Enabled := True;
  WebDBCheckBox1.Enabled := True;
  WebDBCheckBox2.Enabled := True;
  WebDBMemo1.Enabled := True;
  WebSpeedButton4.Visible := True;
  WebSpeedButton5.Visible := True;
  WebDateTimePicker1.Visible:=True;
  WebDateTimePicker2.Visible:=True;

  WebEdit1.Enabled := False;
  WebDBNavigator1.Enabled := False;
  WebButton2.Enabled := False;
  WebButton3.Enabled := False;
  WebToggleButton1.Visible := False;
  WebToggleButton2.Visible := False;
  WebSpeedButton1.Enabled := False;
  WebSpeedButton2.Enabled := False;
  WebDBGrid1.Enabled := False;
  WebDBGrid2.Enabled := False;
end;

procedure TFDocEntrena.DesactivaCaptura;
begin
  WebDBEdit1.Enabled := False;
  WebDBEdit2.Enabled := False;
  WebDBEdit3.Enabled := False;
  WebDBEdit4.Enabled := False;
  WebDBEdit5.Enabled := False;
  WebDBEdit6.Enabled := False;
  WebDBEdit13.Enabled:= False;
  WebDBEdit7.Enabled := False;
  WebButton1.Enabled := False;
  WebButton5.Enabled := False;
  WebDBCheckBox1.Enabled := False;
  WebDBCheckBox2.Enabled := False;
  WebDBMemo1.Enabled := False;
  WebSpeedButton4.Visible := False;
  WebSpeedButton5.Visible := False;
  WebDateTimePicker1.Visible:=False;
  WebDateTimePicker2.Visible:=False;

  WebEdit1.Enabled := True;
  WebDBNavigator1.Enabled := True;
  WebButton2.Enabled := True;
  WebButton3.Enabled := True;
  WebToggleButton1.Visible := True;
  WebToggleButton2.Visible := True;
  WebSpeedButton1.Enabled := True;
  WebSpeedButton2.Enabled := True;
  WebDBGrid1.Enabled := True;
  WebDBGrid2.Enabled := True;
end;

procedure TFDocEntrena.DesactivaTODO;
begin
  WebDBEdit1.Enabled := False;
  WebDBEdit2.Enabled := False;
  WebDBEdit3.Enabled := False;
  WebDBEdit4.Enabled := False;
  WebDBEdit5.Enabled := False;
  WebDBEdit6.Enabled := False;
  WebDBEdit13.Enabled:= False;
  WebDBEdit7.Enabled := False;
  WebButton1.Enabled := False;
  WebButton5.Enabled := False;
  WebDBCheckBox1.Enabled := False;
  WebDBCheckBox2.Enabled := False;
  WebDBMemo1.Enabled := False;
  WebSpeedButton4.Visible := False;
  WebSpeedButton5.Visible := False;

  WebEdit1.Enabled := False;
  WebDBNavigator1.Enabled := False;
  WebButton2.Enabled := False;
  WebButton3.Enabled := False;
  WebToggleButton1.Visible := False;
  WebToggleButton2.Visible := False;
  WebSpeedButton1.Enabled := False;
  WebSpeedButton2.Enabled := False;
  WebDBGrid1.Enabled := False;
  WebDBGrid2.Enabled := False;
end;

procedure TFDocEntrena.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebDBNavigator1 := TDBNavigator.Create(Self);
  WebToggleButton1 := TToggleButton.Create(Self);
  WebToggleButton2 := TToggleButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebButton4 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBMemo1 := TDBMemo.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebDateTimePicker2 := TDateTimePicker.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebButton5 := TButton.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDateTimePicker3 := TDateTimePicker.Create(Self);
  WebDateTimePicker4 := TDateTimePicker.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBCheckBox3 := TDBCheckBox.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebDBGrid3 := TDBGrid.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  WebDBGrid4 := TDBGrid.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  DsEntrenaDoc := TDataSource.Create(Self);
  TEntrenaDocRev := TClientDataSet.Create(Self);
  CEntrenaDocRev := TClientConnection.Create(Self);
  DsEntrenaDocRev := TDataSource.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  CPuestos := TClientConnection.Create(Self);
  TPuestos := TClientDataSet.Create(Self);
  DsPuestos := TDataSource.Create(Self);
  CEntrenaPuestos := TClientConnection.Create(Self);
  TEntrenaPuestos := TClientDataSet.Create(Self);
  DsEntrenaPuestos := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebDBNavigator1.BeforeLoadDFMValues;
  WebToggleButton1.BeforeLoadDFMValues;
  WebToggleButton2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebButton4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBMemo1.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebDateTimePicker2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDateTimePicker3.BeforeLoadDFMValues;
  WebDateTimePicker4.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBCheckBox3.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebDBGrid3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  WebDBGrid4.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  DsEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDocRev.BeforeLoadDFMValues;
  CEntrenaDocRev.BeforeLoadDFMValues;
  DsEntrenaDocRev.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  CPuestos.BeforeLoadDFMValues;
  TPuestos.BeforeLoadDFMValues;
  DsPuestos.BeforeLoadDFMValues;
  CEntrenaPuestos.BeforeLoadDFMValues;
  TEntrenaPuestos.BeforeLoadDFMValues;
  DsEntrenaPuestos.BeforeLoadDFMValues;
  try
    Name := 'FDocEntrena';
    Left := 0;
    Top := 0;
    Caption := 'Documentos de entrenamiento';
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    SetEvent(Self, 'OnCreate', 'FormCreate');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 16;
    WebPanel1.Width := 737;
    WebPanel1.Height := 94;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := clInfoBk;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 570;
    WebLabel1.Top := 22;
    WebLabel1.Width := 143;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Ver solo documentos vigentes';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 570;
    WebLabel2.Top := 50;
    WebLabel2.Width := 148;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Ver solo documentos gen'#233'ricos';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebEdit1.SetParentComponent(WebPanel1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 14;
    WebEdit1.Top := 19;
    WebEdit1.Width := 179;
    WebEdit1.Height := 22;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.SetParentComponent(WebPanel1);
    WebDBNavigator1.Name := 'WebDBNavigator1';
    WebDBNavigator1.Left := 229;
    WebDBNavigator1.Top := 17;
    WebDBNavigator1.Width := 130;
    WebDBNavigator1.Height := 24;
    WebDBNavigator1.HeightPercent := 100.000000000000000000;
    WebDBNavigator1.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.DataSource := DsEntrenaDoc;
    WebDBNavigator1.Hints.BeginUpdate;
    try
      WebDBNavigator1.Hints.Clear;
      WebDBNavigator1.Hints.Add('First');
      WebDBNavigator1.Hints.Add('Prior');
      WebDBNavigator1.Hints.Add('Next');
      WebDBNavigator1.Hints.Add('Last');
      WebDBNavigator1.Hints.Add('Edit');
      WebDBNavigator1.Hints.Add('Post');
      WebDBNavigator1.Hints.Add('Insert');
      WebDBNavigator1.Hints.Add('Delete');
      WebDBNavigator1.Hints.Add('Cancel');
    finally
      WebDBNavigator1.Hints.EndUpdate;
    end;
    WebDBNavigator1.VisibleButtons := [nbFirst,nbPrior,nbNext,nbLast];
    WebToggleButton1.SetParentComponent(WebPanel1);
    WebToggleButton1.Name := 'WebToggleButton1';
    WebToggleButton1.Left := 520;
    WebToggleButton1.Top := 22;
    WebToggleButton1.Width := 44;
    WebToggleButton1.Height := 22;
    SetEvent(WebToggleButton1, Self, 'OnClick', 'WebToggleButton1Click');
    WebToggleButton2.SetParentComponent(WebPanel1);
    WebToggleButton2.Name := 'WebToggleButton2';
    WebToggleButton2.Left := 520;
    WebToggleButton2.Top := 50;
    WebToggleButton2.Width := 44;
    WebToggleButton2.Height := 22;
    SetEvent(WebToggleButton2, Self, 'OnClick', 'WebToggleButton2Click');
    WebSpeedButton6.SetParentComponent(WebPanel1);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 199;
    WebSpeedButton6.Top := 17;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uDocEntrena.WebPanel1.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebButton4.SetParentComponent(WebPanel1);
    WebButton4.Name := 'WebButton4';
    WebButton4.Left := 365;
    WebButton4.Top := 17;
    WebButton4.Width := 96;
    WebButton4.Height := 24;
    WebButton4.Caption := 'Actualizar';
    WebButton4.ChildOrder := 7;
    WebButton4.HeightPercent := 100.000000000000000000;
    WebButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton4, Self, 'OnClick', 'WebButton4Click');
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 762;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 119;
    WebSpeedButton1.Height := 44;
    WebSpeedButton1.Caption := 'Agregar';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uDocEntrena.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 762;
    WebSpeedButton2.Top := 66;
    WebSpeedButton2.Width := 119;
    WebSpeedButton2.Height := 44;
    WebSpeedButton2.Caption := 'Editar';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('uDocEntrena.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 976;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 81;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Salir';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('uDocEntrena.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 8;
    WebPanel2.Top := 116;
    WebPanel2.Width := 737;
    WebPanel2.Height := 334;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 4;
    WebPanel2.Color := clInfoBk;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 14;
    WebLabel3.Top := 24;
    WebLabel3.Width := 58;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Documento:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 14;
    WebLabel4.Top := 71;
    WebLabel4.Width := 58;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Descripci'#243'n:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 14;
    WebLabel5.Top := 118;
    WebLabel5.Width := 54;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Fecha alta:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 150;
    WebLabel6.Top := 118;
    WebLabel6.Width := 43;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Vigencia:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel2);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 14;
    WebLabel7.Top := 165;
    WebLabel7.Width := 44;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Revisi'#243'n:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel2);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 14;
    WebLabel8.Top := 212;
    WebLabel8.Width := 132;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Duraci'#243'n del entrenamiento';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 14;
    WebLabel9.Top := 231;
    WebLabel9.Width := 32;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Horas:';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel2);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 150;
    WebLabel10.Top := 231;
    WebLabel10.Width := 41;
    WebLabel10.Height := 13;
    WebLabel10.Caption := 'Minutos:';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel2);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 392;
    WebLabel11.Top := 24;
    WebLabel11.Width := 32;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'Notas:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(WebPanel2);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 14;
    WebLabel23.Top := 278;
    WebLabel23.Width := 89;
    WebLabel23.Height := 13;
    WebLabel23.Caption := 'Por instrucci'#243'n de:';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebDBEdit4.SetParentComponent(WebPanel2);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 150;
    WebDBEdit4.Top := 137;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 9;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit3';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'FechaFin';
    WebDBEdit4.DataSource := DsEntrenaDoc;
    WebDBEdit1.SetParentComponent(WebPanel2);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 14;
    WebDBEdit1.Top := 43;
    WebDBEdit1.Width := 179;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 1;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Codigo';
    WebDBEdit1.DataSource := DsEntrenaDoc;
    WebDBEdit2.SetParentComponent(WebPanel2);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 14;
    WebDBEdit2.Top := 90;
    WebDBEdit2.Width := 331;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 1;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit1';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'Descripcion';
    WebDBEdit2.DataSource := DsEntrenaDoc;
    WebDBEdit5.SetParentComponent(WebPanel2);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 14;
    WebDBEdit5.Top := 184;
    WebDBEdit5.Width := 115;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 1;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit1';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'Revision';
    WebDBEdit5.DataSource := DsEntrenaDoc;
    WebButton1.SetParentComponent(WebPanel2);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 135;
    WebButton1.Top := 184;
    WebButton1.Width := 74;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Cambiar';
    WebButton1.ChildOrder := 10;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebDBEdit6.SetParentComponent(WebPanel2);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 14;
    WebDBEdit6.Top := 250;
    WebDBEdit6.Width := 115;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 1;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit1';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'DuracionH';
    WebDBEdit6.DataSource := DsEntrenaDoc;
    WebDBEdit7.SetParentComponent(WebPanel2);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 150;
    WebDBEdit7.Top := 250;
    WebDBEdit7.Width := 115;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 1;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit1';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'DuracionM';
    WebDBEdit7.DataSource := DsEntrenaDoc;
    WebDBMemo1.SetParentComponent(WebPanel2);
    WebDBMemo1.Name := 'WebDBMemo1';
    WebDBMemo1.Left := 392;
    WebDBMemo1.Top := 43;
    WebDBMemo1.Width := 185;
    WebDBMemo1.Height := 135;
    WebDBMemo1.AutoSize := False;
    WebDBMemo1.HeightPercent := 100.000000000000000000;
    WebDBMemo1.Lines.BeginUpdate;
    try
      WebDBMemo1.Lines.Clear;
      WebDBMemo1.Lines.Add('WebDBMemo1');
    finally
      WebDBMemo1.Lines.EndUpdate;
    end;
    WebDBMemo1.SelLength := 0;
    WebDBMemo1.SelStart := 0;
    WebDBMemo1.WidthPercent := 100.000000000000000000;
    WebDBMemo1.DataField := 'Notas';
    WebDBMemo1.DataSource := DsEntrenaDoc;
    WebSpeedButton4.SetParentComponent(WebPanel2);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 616;
    WebSpeedButton4.Top := 24;
    WebSpeedButton4.Width := 41;
    WebSpeedButton4.Height := 33;
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('uDocEntrena.WebPanel2.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.Layout := blGlyphTop;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebPanel2);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 663;
    WebSpeedButton5.Top := 24;
    WebSpeedButton5.Width := 41;
    WebSpeedButton5.Height := 33;
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uDocEntrena.WebPanel2.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.Layout := blGlyphTop;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebDBCheckBox1.SetParentComponent(WebPanel2);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 392;
    WebDBCheckBox1.Top := 195;
    WebDBCheckBox1.Width := 137;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Documento gen'#233'rico';
    WebDBCheckBox1.ChildOrder := 19;
    WebDBCheckBox1.Color := clNone;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.State := cbUnchecked;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'Generico';
    WebDBCheckBox1.DataSource := DsEntrenaDoc;
    WebDBCheckBox2.SetParentComponent(WebPanel2);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 392;
    WebDBCheckBox2.Top := 219;
    WebDBCheckBox2.Width := 137;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'Documento vigente';
    WebDBCheckBox2.ChildOrder := 19;
    WebDBCheckBox2.Color := clNone;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.State := cbUnchecked;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox2.DataField := 'Vigente';
    WebDBCheckBox2.DataSource := DsEntrenaDoc;
    WebDateTimePicker2.SetParentComponent(WebPanel2);
    WebDateTimePicker2.Name := 'WebDateTimePicker2';
    WebDateTimePicker2.Left := 210;
    WebDateTimePicker2.Top := 137;
    WebDateTimePicker2.Width := 61;
    WebDateTimePicker2.Height := 22;
    WebDateTimePicker2.HeightPercent := 100.000000000000000000;
    WebDateTimePicker2.WidthPercent := 100.000000000000000000;
    WebDateTimePicker2.BorderStyle := bsSingle;
    WebDateTimePicker2.ChildOrder := 10;
    WebDateTimePicker2.Color := clWhite;
    WebDateTimePicker2.Date := 46009.395262210650000000;
    WebDateTimePicker2.Role := '';
    WebDateTimePicker2.Text := '';
    WebDBEdit3.SetParentComponent(WebPanel2);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 14;
    WebDBEdit3.Top := 137;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 9;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'FechaAlta';
    WebDBEdit3.DataSource := DsEntrenaDoc;
    WebDateTimePicker1.SetParentComponent(WebPanel2);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 74;
    WebDateTimePicker1.Top := 137;
    WebDateTimePicker1.Width := 61;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.HeightPercent := 100.000000000000000000;
    WebDateTimePicker1.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 10;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 46009.395262210650000000;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    WebDateTimePicker1.Visible := False;
    WebDBEdit13.SetParentComponent(WebPanel2);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 14;
    WebDBEdit13.Top := 297;
    WebDBEdit13.Width := 179;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 1;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit1';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'PorInstruccionDe';
    WebDBEdit13.DataSource := DsEntrenaDoc;
    WebButton5.SetParentComponent(WebPanel2);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 215;
    WebButton5.Top := 183;
    WebButton5.Width := 114;
    WebButton5.Height := 24;
    WebButton5.Caption := 'Imprime faltantes';
    WebButton5.ChildOrder := 7;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton5, Self, 'OnClick', 'WebButton5Click');
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 8;
    WebDBGrid1.Top := 456;
    WebDBGrid1.Width := 537;
    WebDBGrid1.Height := 301;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Codigo';
      Title := 'C'#243'digo';
      Width := 120;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid1.DataSource := DsEntrenaDoc;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 5;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 120;
    WebDBGrid1.ColWidths[2] := 350;
    WebDBGrid2.SetParentComponent(Self);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 551;
    WebDBGrid2.Top := 456;
    WebDBGrid2.Width := 442;
    WebDBGrid2.Height := 146;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Revision';
      Title := 'Revisiones';
      Width := 80;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'RevisionAnt';
      Title := 'Revisi'#243'n Ant.';
      Width := 80;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Fecha';
      Title := 'Fecha';
      Width := 80;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := '';
      Width := 150;
    end;
    WebDBGrid2.DataSource := DsEntrenaDocRev;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 6;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 80;
    WebDBGrid2.ColWidths[2] := 80;
    WebDBGrid2.ColWidths[3] := 80;
    WebDBGrid2.ColWidths[4] := 150;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 1079;
    WebPanel3.Top := 312;
    WebPanel3.Width := 658;
    WebPanel3.Height := 326;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 8;
    WebPanel3.Color := 16764573;
    WebPanel3.Visible := False;
    WebLabel12.SetParentComponent(WebPanel3);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 30;
    WebLabel12.Top := 74;
    WebLabel12.Width := 75;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'Nueva revisi'#243'n:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 30;
    WebLabel13.Top := 27;
    WebLabel13.Width := 85;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Revisi'#243'n anterior:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel3);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 30;
    WebLabel15.Top := 121;
    WebLabel15.Width := 74;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'Fecha de inicio:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel3);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 222;
    WebLabel16.Top := 121;
    WebLabel16.Width := 87;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Fecha de t'#233'rmino:';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel3);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 30;
    WebLabel17.Top := 215;
    WebLabel17.Width := 100;
    WebLabel17.Height := 13;
    WebLabel17.Caption := 'Por instrucciones de:';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel3);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 30;
    WebLabel18.Top := 168;
    WebLabel18.Width := 32;
    WebLabel18.Height := 13;
    WebLabel18.Caption := 'Notas:';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel3);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 167;
    WebLabel14.Top := 27;
    WebLabel14.Width := 58;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Documento:';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 530;
    WebSpeedButton7.Top := 32;
    WebSpeedButton7.Width := 41;
    WebSpeedButton7.Height := 33;
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('uDocEntrena.WebPanel3.WebSpeedButton7.Glyph.png');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.Layout := blGlyphTop;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 577;
    WebSpeedButton8.Top := 32;
    WebSpeedButton8.Width := 41;
    WebSpeedButton8.Height := 33;
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.Glyph.LoadFromFile('uDocEntrena.WebPanel3.WebSpeedButton8.Glyph.png');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.Layout := blGlyphTop;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebDBEdit8.SetParentComponent(WebPanel3);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 30;
    WebDBEdit8.Top := 93;
    WebDBEdit8.Width := 115;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 1;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit1';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'Revision';
    WebDBEdit8.DataSource := DsEntrenaDocRev;
    WebDBEdit9.SetParentComponent(WebPanel3);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 30;
    WebDBEdit9.Top := 46;
    WebDBEdit9.Width := 115;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 1;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.ReadOnly := True;
    WebDBEdit9.Text := 'WebDBEdit1';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'RevisionAnt';
    WebDBEdit9.DataSource := DsEntrenaDocRev;
    WebDateTimePicker3.SetParentComponent(WebPanel3);
    WebDateTimePicker3.Name := 'WebDateTimePicker3';
    WebDateTimePicker3.Left := 30;
    WebDateTimePicker3.Top := 140;
    WebDateTimePicker3.Width := 170;
    WebDateTimePicker3.Height := 22;
    WebDateTimePicker3.HeightPercent := 100.000000000000000000;
    WebDateTimePicker3.WidthPercent := 100.000000000000000000;
    WebDateTimePicker3.BorderStyle := bsSingle;
    WebDateTimePicker3.ChildOrder := 8;
    WebDateTimePicker3.Color := clWhite;
    WebDateTimePicker3.Date := 46030.707675000000000000;
    WebDateTimePicker3.Role := '';
    WebDateTimePicker3.Text := '';
    WebDateTimePicker4.SetParentComponent(WebPanel3);
    WebDateTimePicker4.Name := 'WebDateTimePicker4';
    WebDateTimePicker4.Left := 222;
    WebDateTimePicker4.Top := 140;
    WebDateTimePicker4.Width := 170;
    WebDateTimePicker4.Height := 22;
    WebDateTimePicker4.HeightPercent := 100.000000000000000000;
    WebDateTimePicker4.WidthPercent := 100.000000000000000000;
    WebDateTimePicker4.BorderStyle := bsSingle;
    WebDateTimePicker4.ChildOrder := 8;
    WebDateTimePicker4.Color := clWhite;
    WebDateTimePicker4.Date := 46030.707675000000000000;
    WebDateTimePicker4.Role := '';
    WebDateTimePicker4.Text := '';
    WebDBEdit11.SetParentComponent(WebPanel3);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 30;
    WebDBEdit11.Top := 234;
    WebDBEdit11.Width := 170;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 1;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit1';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'Descripcion';
    WebDBEdit11.DataSource := DsEntrenaDocRev;
    WebDBEdit12.SetParentComponent(WebPanel3);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 30;
    WebDBEdit12.Top := 187;
    WebDBEdit12.Width := 362;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 1;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit1';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'Notas';
    WebDBEdit12.DataSource := DsEntrenaDocRev;
    WebDBCheckBox3.SetParentComponent(WebPanel3);
    WebDBCheckBox3.Name := 'WebDBCheckBox3';
    WebDBCheckBox3.Left := 30;
    WebDBCheckBox3.Top := 270;
    WebDBCheckBox3.Width := 170;
    WebDBCheckBox3.Height := 22;
    WebDBCheckBox3.Caption := '     Requiere reentrenamiento';
    WebDBCheckBox3.ChildOrder := 19;
    WebDBCheckBox3.Color := clNone;
    WebDBCheckBox3.HeightPercent := 100.000000000000000000;
    WebDBCheckBox3.State := cbUnchecked;
    WebDBCheckBox3.WidthPercent := 100.000000000000000000;
    WebDBCheckBox3.DataField := 'Entrena';
    WebDBCheckBox3.DataSource := DsEntrenaDocRev;
    WebDBEdit10.SetParentComponent(WebPanel3);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 167;
    WebDBEdit10.Top := 46;
    WebDBEdit10.Width := 115;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 1;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.ReadOnly := True;
    WebDBEdit10.Text := 'WebDBEdit1';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'Documento';
    WebDBEdit10.DataSource := DsEntrenaDocRev;
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 551;
    WebPanel4.Top := 608;
    WebPanel4.Width := 442;
    WebPanel4.Height := 90;
    WebPanel4.HeightPercent := 100.000000000000000000;
    WebPanel4.WidthPercent := 100.000000000000000000;
    WebPanel4.BorderColor := clSilver;
    WebPanel4.BorderStyle := bsSingle;
    WebPanel4.ChildOrder := 8;
    WebPanel4.Color := 16764573;
    WebButton2.SetParentComponent(WebPanel4);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 11;
    WebButton2.Top := 11;
    WebButton2.Width := 169;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Asignar matrices';
    WebButton2.ChildOrder := 2;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebButton3.SetParentComponent(WebPanel4);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 11;
    WebButton3.Top := 42;
    WebButton3.Width := 169;
    WebButton3.Height := 25;
    WebButton3.Caption := 'Generar DWK 013';
    WebButton3.ChildOrder := 2;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    WebPanel5.SetParentComponent(Self);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 1079;
    WebPanel5.Top := 21;
    WebPanel5.Width := 716;
    WebPanel5.Height := 273;
    WebPanel5.HeightPercent := 100.000000000000000000;
    WebPanel5.WidthPercent := 100.000000000000000000;
    WebPanel5.BorderColor := clSilver;
    WebPanel5.BorderStyle := bsSingle;
    WebPanel5.ChildOrder := 8;
    WebPanel5.Color := clMoneyGreen;
    WebPanel5.Visible := False;
    WebLabel25.SetParentComponent(WebPanel5);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 30;
    WebLabel25.Top := 28;
    WebLabel25.Width := 58;
    WebLabel25.Height := 13;
    WebLabel25.Caption := 'Documento:';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebPanel5);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 231;
    WebLabel20.Top := 28;
    WebLabel20.Width := 58;
    WebLabel20.Height := 13;
    WebLabel20.Caption := 'Descripci'#243'n:';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WebPanel5);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 30;
    WebLabel19.Top := 75;
    WebLabel19.Width := 33;
    WebLabel19.Height := 13;
    WebLabel19.Caption := 'Puesto';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel5);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 30;
    WebLabel22.Top := 122;
    WebLabel22.Width := 69;
    WebLabel22.Height := 13;
    WebLabel22.Caption := 'Departamento';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebSpeedButton9.SetParentComponent(WebPanel5);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 140;
    WebSpeedButton9.Top := 212;
    WebSpeedButton9.Width := 104;
    WebSpeedButton9.Height := 33;
    WebSpeedButton9.Caption := 'Cerrar';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.Glyph.LoadFromFile('uDocEntrena.WebPanel5.WebSpeedButton9.Glyph.png');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(WebPanel5);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 30;
    WebSpeedButton10.Top := 212;
    WebSpeedButton10.Width := 104;
    WebSpeedButton10.Height := 33;
    WebSpeedButton10.Caption := 'Aceptar';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uDocEntrena.WebPanel5.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebDBEdit17.SetParentComponent(WebPanel5);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 30;
    WebDBEdit17.Top := 47;
    WebDBEdit17.Width := 195;
    WebDBEdit17.Height := 22;
    WebDBEdit17.ChildOrder := 1;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.ReadOnly := True;
    WebDBEdit17.Text := 'WebDBEdit1';
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebDBEdit17.DataField := 'Codigo';
    WebDBEdit17.DataSource := DsEntrenaDoc;
    WebDBEdit14.SetParentComponent(WebPanel5);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 231;
    WebDBEdit14.Top := 47;
    WebDBEdit14.Width := 274;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 1;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.ReadOnly := True;
    WebDBEdit14.Text := 'WebDBEdit1';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'Descripcion';
    WebDBEdit14.DataSource := DsEntrenaDoc;
    WebEdit2.SetParentComponent(WebPanel5);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 30;
    WebEdit2.Top := 94;
    WebEdit2.Width := 69;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 4;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit2, Self, 'OnEnter', 'WebEdit2Enter');
    WebEdit3.SetParentComponent(WebPanel5);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 105;
    WebEdit3.Top := 94;
    WebEdit3.Width := 400;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 4;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    WebEdit5.SetParentComponent(WebPanel5);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 30;
    WebEdit5.Top := 141;
    WebEdit5.Width := 54;
    WebEdit5.Height := 22;
    WebEdit5.ChildOrder := 4;
    WebEdit5.HeightPercent := 100.000000000000000000;
    WebEdit5.WidthPercent := 100.000000000000000000;
    WebEdit6.SetParentComponent(WebPanel5);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 90;
    WebEdit6.Top := 141;
    WebEdit6.Width := 54;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 4;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(WebPanel5);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 150;
    WebEdit7.Top := 141;
    WebEdit7.Width := 54;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 4;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit8.SetParentComponent(WebPanel5);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 210;
    WebEdit8.Top := 141;
    WebEdit8.Width := 54;
    WebEdit8.Height := 22;
    WebEdit8.ChildOrder := 4;
    WebEdit8.HeightPercent := 100.000000000000000000;
    WebEdit8.WidthPercent := 100.000000000000000000;
    WebEdit9.SetParentComponent(WebPanel5);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 270;
    WebEdit9.Top := 141;
    WebEdit9.Width := 54;
    WebEdit9.Height := 22;
    WebEdit9.ChildOrder := 4;
    WebEdit9.HeightPercent := 100.000000000000000000;
    WebEdit9.WidthPercent := 100.000000000000000000;
    WebEdit10.SetParentComponent(WebPanel5);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 30;
    WebEdit10.Top := 169;
    WebEdit10.Width := 54;
    WebEdit10.Height := 22;
    WebEdit10.ChildOrder := 4;
    WebEdit10.HeightPercent := 100.000000000000000000;
    WebEdit10.WidthPercent := 100.000000000000000000;
    WebEdit11.SetParentComponent(WebPanel5);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 90;
    WebEdit11.Top := 169;
    WebEdit11.Width := 54;
    WebEdit11.Height := 22;
    WebEdit11.ChildOrder := 4;
    WebEdit11.HeightPercent := 100.000000000000000000;
    WebEdit11.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(WebPanel5);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 150;
    WebEdit12.Top := 169;
    WebEdit12.Width := 54;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 4;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(WebPanel5);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 210;
    WebEdit13.Top := 169;
    WebEdit13.Width := 54;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 4;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.WidthPercent := 100.000000000000000000;
    WebEdit14.SetParentComponent(WebPanel5);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 270;
    WebEdit14.Top := 169;
    WebEdit14.Width := 54;
    WebEdit14.Height := 22;
    WebEdit14.ChildOrder := 4;
    WebEdit14.HeightPercent := 100.000000000000000000;
    WebEdit14.WidthPercent := 100.000000000000000000;
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 1079;
    WebPanel6.Top := 660;
    WebPanel6.Width := 658;
    WebPanel6.Height := 326;
    WebPanel6.HeightPercent := 100.000000000000000000;
    WebPanel6.WidthPercent := 100.000000000000000000;
    WebPanel6.BorderColor := clSilver;
    WebPanel6.BorderStyle := bsSingle;
    WebPanel6.ChildOrder := 8;
    WebPanel6.Color := 10797567;
    WebPanel6.Visible := False;
    WebLabel21.SetParentComponent(WebPanel6);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 30;
    WebLabel21.Top := 27;
    WebLabel21.Width := 196;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Busca puesto (C'#243'digo/Clave del puesto):';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebDBGrid3.SetParentComponent(WebPanel6);
    WebDBGrid3.Name := 'WebDBGrid3';
    WebDBGrid3.Left := 30;
    WebDBGrid3.Top := 79;
    WebDBGrid3.Width := 595;
    WebDBGrid3.Height := 214;
    WebDBGrid3.Columns.Clear;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Clave';
      Title := 'Puesto';
      Width := 150;
    end;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid3.DataSource := DsPuestos;
    WebDBGrid3.FixedCols := 1;
    WebDBGrid3.TabOrder := 0;
    WebDBGrid3.HeightPercent := 100.000000000000000000;
    WebDBGrid3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid3, Self, 'OnDblClick', 'WebDBGrid3DblClick');
    WebDBGrid3.ColWidths[0] := 24;
    WebDBGrid3.ColWidths[1] := 150;
    WebDBGrid3.ColWidths[2] := 350;
    WebEdit4.SetParentComponent(WebPanel6);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 30;
    WebEdit4.Top := 46;
    WebEdit4.Width := 196;
    WebEdit4.Height := 22;
    WebEdit4.ChildOrder := 4;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.WidthPercent := 100.000000000000000000;
    WebSpeedButton11.SetParentComponent(WebPanel6);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 249;
    WebSpeedButton11.Top := 40;
    WebSpeedButton11.Width := 100;
    WebSpeedButton11.Height := 24;
    WebSpeedButton11.Caption := 'Buscar';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uDocEntrena.WebPanel6.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton12.SetParentComponent(WebPanel6);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 355;
    WebSpeedButton12.Top := 40;
    WebSpeedButton12.Width := 100;
    WebSpeedButton12.Height := 24;
    WebSpeedButton12.Caption := 'Cancelar';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.Glyph.LoadFromFile('uDocEntrena.WebPanel6.WebSpeedButton12.Glyph.png');
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    WebDBGrid4.SetParentComponent(Self);
    WebDBGrid4.Name := 'WebDBGrid4';
    WebDBGrid4.Left := 551;
    WebDBGrid4.Top := 704;
    WebDBGrid4.Width := 442;
    WebDBGrid4.Height := 140;
    WebDBGrid4.Columns.Clear;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Notas';
      Title := 'Notas';
      Width := 420;
    end;
    WebDBGrid4.DataSource := DsEntrenaDocRev;
    WebDBGrid4.FixedCols := 0;
    WebDBGrid4.TabOrder := 11;
    WebDBGrid4.HeightPercent := 100.000000000000000000;
    WebDBGrid4.WidthPercent := 100.000000000000000000;
    WebDBGrid4.ColWidths[0] := 420;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 864;
    TEntrenaDoc.Top := 136;
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    SetEvent(CEntrenaDoc, Self, 'OnDataReceived', 'CEntrenaDocDataReceived');
    CEntrenaDoc.Left := 792;
    CEntrenaDoc.Top := 136;
    DsEntrenaDoc.SetParentComponent(Self);
    DsEntrenaDoc.Name := 'DsEntrenaDoc';
    DsEntrenaDoc.DataSet := TEntrenaDoc;
    SetEvent(DsEntrenaDoc, Self, 'OnDataChange', 'DsEntrenaDocDataChange');
    DsEntrenaDoc.Left := 936;
    DsEntrenaDoc.Top := 136;
    TEntrenaDocRev.SetParentComponent(Self);
    TEntrenaDocRev.Name := 'TEntrenaDocRev';
    TEntrenaDocRev.Connection := CEntrenaDocRev;
    TEntrenaDocRev.Left := 864;
    TEntrenaDocRev.Top := 184;
    CEntrenaDocRev.SetParentComponent(Self);
    CEntrenaDocRev.Name := 'CEntrenaDocRev';
    CEntrenaDocRev.Active := False;
    CEntrenaDocRev.BeforeConnect := CEntrenaDocRevBeforeConnect;
    SetEvent(CEntrenaDocRev, Self, 'OnDataReceived', 'CEntrenaDocRevDataReceived');
    CEntrenaDocRev.Left := 792;
    CEntrenaDocRev.Top := 184;
    DsEntrenaDocRev.SetParentComponent(Self);
    DsEntrenaDocRev.Name := 'DsEntrenaDocRev';
    DsEntrenaDocRev.DataSet := TEntrenaDocRev;
    DsEntrenaDocRev.Left := 936;
    DsEntrenaDocRev.Top := 184;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 928;
    WebHttpRequest1.Top := 80;
    CPuestos.SetParentComponent(Self);
    CPuestos.Name := 'CPuestos';
    CPuestos.Active := False;
    CPuestos.Left := 792;
    CPuestos.Top := 288;
    TPuestos.SetParentComponent(Self);
    TPuestos.Name := 'TPuestos';
    TPuestos.Connection := CPuestos;
    TPuestos.Left := 856;
    TPuestos.Top := 288;
    DsPuestos.SetParentComponent(Self);
    DsPuestos.Name := 'DsPuestos';
    DsPuestos.DataSet := TPuestos;
    DsPuestos.Left := 936;
    DsPuestos.Top := 288;
    CEntrenaPuestos.SetParentComponent(Self);
    CEntrenaPuestos.Name := 'CEntrenaPuestos';
    CEntrenaPuestos.Active := False;
    CEntrenaPuestos.Left := 792;
    CEntrenaPuestos.Top := 232;
    TEntrenaPuestos.SetParentComponent(Self);
    TEntrenaPuestos.Name := 'TEntrenaPuestos';
    TEntrenaPuestos.Connection := CEntrenaPuestos;
    TEntrenaPuestos.Left := 864;
    TEntrenaPuestos.Top := 232;
    DsEntrenaPuestos.SetParentComponent(Self);
    DsEntrenaPuestos.Name := 'DsEntrenaPuestos';
    DsEntrenaPuestos.DataSet := TEntrenaPuestos;
    DsEntrenaPuestos.Left := 936;
    DsEntrenaPuestos.Top := 232;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebDBNavigator1.AfterLoadDFMValues;
    WebToggleButton1.AfterLoadDFMValues;
    WebToggleButton2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebButton4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBMemo1.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebDateTimePicker2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDateTimePicker3.AfterLoadDFMValues;
    WebDateTimePicker4.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBCheckBox3.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebDBGrid3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    WebDBGrid4.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    DsEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDocRev.AfterLoadDFMValues;
    CEntrenaDocRev.AfterLoadDFMValues;
    DsEntrenaDocRev.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    CPuestos.AfterLoadDFMValues;
    TPuestos.AfterLoadDFMValues;
    DsPuestos.AfterLoadDFMValues;
    CEntrenaPuestos.AfterLoadDFMValues;
    TEntrenaPuestos.AfterLoadDFMValues;
    DsEntrenaPuestos.AfterLoadDFMValues;
  end;
end;

end.
